export const PRODUCT_TYPE_KEYS = {
    base: 'product-types',
    all: ['product-types'],
    list: ['product-types', 'list'],
    detail: (id: string) => ['product-types', 'detail', id]
} as const;
